import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';

function ButtonGroup({ children, className }) {
  return <div className={`${styles.buttonGroup}${className ? ` ${className}` : ''}`}>{children}</div>;
}

ButtonGroup.defaultProps = {
  className: null
};

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default ButtonGroup;
